import Vue from 'vue';
import Vuex from 'vuex';

import core from './modules/core';
import user from './modules/user';
import sidebar from './modules/sidebar';
import order from './modules/order';
import set from './modules/set';
import favorites from './modules/favorites';
import tags from './modules/tags';
import sorting from './modules/sorting';
import invoices from './modules/invoices';
import customerItems from './modules/customer-items';
import downloads from './modules/downloads';
import albums from './modules/albums';
import products from './modules/products';
import cart from './modules/cart';
import checkout from './modules/checkout';
import shippingOptions from './modules/shipping-options';
import paymentOptions from './modules/payment-options';
import pricelists from './modules/pricelists';
import coupon from './modules/coupon';
import photoEditor from './modules/photo-editor';
import mobileMenu from './modules/mobile-menu';
import contacts from './modules/contacts';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    core,
    user,
    sidebar,
    order,
    set,
    favorites,
    tags,
    sorting,
    invoices,
    customerItems,
    downloads,
    albums,
    products,
    cart,
    checkout,
    shippingOptions,
    paymentOptions,
    pricelists,
    coupon,
    photoEditor,
    mobileMenu,
    contacts,
  },
});
